  import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Optional,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../services/common/authentication.service';
import { StorageService } from '../../../services/common/storage.service';
import { ApiUrlHelper } from '../../../services/api-url-helper/api-url-helper';
import { ApiService } from '../../../services/api.service';
import { LanguageService } from '../../../services/languageService/language-service.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
  animations: [
    trigger('slideInOut', [
      state(
        'void',
        style({
          opacity: 0,
          transform: 'translateY(-10px) scale(0.95)',
        })
      ),
      transition('void <=> *', animate('200ms ease-out')),
    ]),
  ],
})
export class NotificationComponent implements OnInit {
  notificationCount: number = 0;
  showNotifications: boolean = false;
  notifications: any[] = [];
  UserType: any;
  id: any;
  loader : boolean = true;

  @Output() notificationLength = new EventEmitter<number>(); //step
  @ViewChild('notificationPanel') notificationPanel!: ElementRef;
  renderer: any;

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private storageService: StorageService,
    private url: ApiUrlHelper,
    private apiservice: ApiService,
    private translate: TranslateService,
    private languageService: LanguageService
  ) {
    this.translate.setDefaultLang('eng');
  }

  ngOnInit(): void {
    this.languageService.language$.subscribe((language) => {
      this.translate.use(language);
    });
    this.UserType = this.storageService.getTokenData().UserTypeId;
    this.id = this.storageService.getTokenData().UserId;
    this.getNotificationList();
  }

  getNotificationList() {
    this.loader = true;
    const obj = {
      pageNumber: 1,
      pageSize: 50000,
      orderBy: '',
      sortOrder: '',
      search: '',
    };

    const apiUrl = this.url.apiUrl.notification.getNotificationList;

    this.apiservice.doPost(apiUrl, obj).subscribe({
      next: (data) => {
        this.loader = false;
        if (data.Success) {
          this.notifications = data.Data;
          this.notificationCount =
            this.notifications.length > 0
              ? this.notifications.filter((item: any) => !item.IsViewed).length
              : 0;
          this.notifications = this.notifications
            .filter((item: any) => !item.IsViewed)
            .slice(0, 3);
        }
      },
      error: () => {
        this.loader = false;
      },
    });
  }

  // Mark single notification as read
  markAsRead(NotificationId: number) {
    const apiurl = this.url.apiUrl.notification.updateViewStatus;
    const objData = {
      NotificationId: NotificationId,
    };
    this.apiservice.doPost(apiurl, objData).subscribe({
      next: (res) => {
        if (res && res.Success) {
          this.getNotificationList();
          this.notificationLength.emit(this.notificationCount);
        }
      },
    });
  }

  markAllAsRead() {
    const apiurl = this.url.apiUrl.notification.updateNotificationReadAll;
    this.apiservice.doGet(apiurl).subscribe({
      next: (res) => {
        if (res && res.Success) {
          this.getNotificationList();
          this.notificationLength.emit(this.notificationCount);
        }
      },
    });
  }

  viewAll() {
    const panel = document.getElementById('notificationPanel');
    if (panel) {
      panel.style.display = 'none';
    }

    if (this.UserType == 1) {
      this.router.navigate(['/admin/notifications']);
    } else {
      this.router.navigate(['/notifications']);
    }
  }

  getTimeAgo(inputDate: string | Date): string {
    const now = new Date();
    const date = new Date(inputDate);
    const diffMs = now.getTime() - date.getTime();
    const diffSecs = Math.floor(diffMs / 1000);
    const diffMins = Math.floor(diffSecs / 60);
    const diffHrs = Math.floor(diffMins / 60);

    const isToday = now.toDateString() === date.toDateString();
    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);
    const isYesterday = yesterday.toDateString() === date.toDateString();

    const formatTime = (date: Date) => {
      const hours = date.getHours() % 12 || 12;
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
      return `${hours}:${minutes} ${ampm}`;
    };

    if (diffSecs < 60) {
      return this.translate.instant('JUST_NOW');
    } else if (diffMins < 60) {
      const key = diffMins === 1 ? 'MINUTE_AGO' : 'MINUTES_AGO';
      return this.translate.instant(key, { minutes: diffMins });
    } else if (diffHrs < 24) {
      const key = diffHrs === 1 ? 'HOUR_AGO' : 'HOURS_AGO';
      return this.translate.instant(key, { hours: diffHrs });
    } else if (isToday) {
      return this.translate.instant('TODAY_AT', { time : formatTime(date) });
    } else if (isYesterday) {
      return this.translate.instant('YESTERDAY_AT', { time : formatTime(date) });
    } else {
      const dateStr = date.toLocaleDateString(this.translate.currentLang === 'es' ? 'es-ES' : undefined, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
      return this.translate.instant('DATE_AT', { date : dateStr ,time : formatTime(date) });
    }
  }
}
